import { FC, ReactNode } from 'react';

import { NotificationName } from 'utils/constants/notification';

import dashboardBannerButtonClick from '@hh.ru/analytics-js-events/build/clickme/employer/common/dashboard_banner_button_click';
import { Link } from '@hh.ru/redux-spa-middleware';

import HoverTip, { TipPlacement } from 'bloko/blocks/drop/Tip/HoverTip';
import BlokoLink from 'bloko/blocks/link';
import Text from 'bloko/blocks/text';

import useTrls from 'hooks/translation/useTrls';

import PreviewTip from 'components/Banner/Preview/PreviewTip';

import { addNotification } from 'store/models/notification';
import { useDispatch } from 'store/utils';

import styles from 'components/Banner/Preview/BannerPreviewDescription/BannerPreviewDescription.module.less';

interface BannerPreviewDesciptionProps {
    bannerAction: string;
    campaignId: number;
    bannerId: number;
    isCampaignArchived: boolean;
    isReadOnlyAccount: boolean;
    text: string;
    title: string;
    vacancyId: number | null;
    url: string;
    isInformationCampaign: boolean;
}

const tipTrl = 'dashboard.CampaignList.Banner.Preview.tip.noEdit';

const BannerPreviewDesciption: FC<BannerPreviewDesciptionProps> = ({
    bannerAction,
    isCampaignArchived,
    vacancyId,
    isReadOnlyAccount,
    text,
    title,
    campaignId,
    bannerId,
    url,
    isInformationCampaign,
}) => {
    const dispatch = useDispatch();
    const trl = useTrls();

    const sendAnalytics = () => dashboardBannerButtonClick({ buttonName: 'banner_title', campaignId, bannerId });

    const copyLinkToClipboard = async () => {
        await navigator.clipboard.writeText(url);
        dispatch(addNotification(NotificationName.BannerLinkCopyToClipboardSuccess));
    };

    let titleNode: ReactNode;

    if (isInformationCampaign) {
        titleNode = !isCampaignArchived ? (
            <BlokoLink Element={Link} to={bannerAction} data-qa="ad-block__banner-edit-link" onClick={sendAnalytics}>
                {title}
            </BlokoLink>
        ) : (
            <>{title}</>
        );
    } else {
        titleNode = (
            <PreviewTip tipText={trl(tipTrl)} dataQA="ad-block__banner-edit-link">
                {title}
            </PreviewTip>
        );
    }
    if (isReadOnlyAccount) {
        titleNode = <>{title}</>;
    }

    return (
        <div className={styles.bannerPreviewDescription}>
            <div>
                {titleNode}
                <p data-qa="ad-block__banner-text">{text}</p>
            </div>
            {!vacancyId && (
                <HoverTip render={() => url} placement={TipPlacement.Bottom}>
                    <div className={styles.bannerPreviewLink} onClick={copyLinkToClipboard}>
                        <Text Element="span" data-qa="ad-block__banner-link">
                            {url}
                        </Text>
                    </div>
                </HoverTip>
            )}
        </div>
    );
};

export default BannerPreviewDesciption;
